// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1mTJq","inner":"Footer_inner__1M35I"};